import _ from 'lodash';
import { useHistory } from 'react-router';

const usePasosEmision = () => {
  const history = useHistory();

  const verificarPolizaCompletada = (pasos) => {
    const isCompleted = pasos.every((paso) => paso?.completado);    
    if (isCompleted) {
      const ultimoPaso = _.maxBy(pasos, 'orden');      
      return history.push(ultimoPaso.goTo);
    }
  };

  return {
    verificarPolizaCompletada,
  };
};

export default usePasosEmision;
